<template>
  <el-dialog
    title='分配供应商'
    :visible.sync='visible'
    width='500px'
    center
    :close-on-click-modal='false'
    @close='closeDialog'>
    <el-form :model='form' label-width='120px' :rules='rules' ref='ruleForm'
             size='medium' :validate-on-rule-change='false'>
      <el-form-item label='账号名称：' prop='userId'>
        <el-select v-model='form.userId' filterable size='mini' style='width: 100%;'
                   placeholder='请选择账号名称' @change='getSuppliersById'>
          <el-option v-for='item in userOptions' :key='item.id' :label='item.empNm'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <el-form-item label='供应商名称：'>
        <el-select v-model='form.supplierIds' collapse-tags filterable multiple size='mini'
                   style='width: 100%; ' placeholder='请选择供应商名称'>
          <el-option v-for='item in suppliersOptions' :key='item.id' :label='item.name'
                     :value='item.id' />
        </el-select>
      </el-form-item>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>
          确定
        </el-button>
        <el-button size='medium' class='resetBtn' @click='closeDialog'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { getUser, getSuppliersById, submitSuppliers } from '@/service/DevOps';

  export default {
    name: 'index',
    components: { divBorder },
    data() {
      return {
        visible: false,
        form: {
          userId: '',
          supplierIds: [],
        },
        submitLoading: false,
        userOptions: [],
        suppliersOptions: [],
        rules: {
          userId: [
            {
              required: true,
              message: '请选择账号名称',
              trigger: 'change',
            },
          ],
        },
      };
    },
    mounted() {
      this.getDefaultData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      getDefaultData() {
        this.getUser();
      },
      async getUser() {
        const {
          status,
          message,
          data,
        } = await getUser();
        if (status !== 0) return this.$message.warning(message);
        this.userOptions = data;
      },
      async getSuppliersById() {
        const {
          status,
          message,
          data,
        } = await getSuppliersById(this.form.userId);
        if (status !== 0) return this.$message.warning(message);
        this.suppliersOptions = data.supplier.allList;
        this.form.supplierIds = data.supplier.userList || [];
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await submitSuppliers({
              ...this.form,
              supplierIds: this.form.supplierIds.join(','),
            });
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.closeDialog();
          }
        });
      },
      openDialog() {
        this.visible = true;
        this.$refs.ruleForm.resetFields();
      },
      closeDialog() {
        this.visible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
    },
  };
</script>

<style lang='scss' scoped>
  .el-form-item {
    margin-top: 18px;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px 0;

    button {
      margin: 0 15px;
    }
  }
</style>
